import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Cargá acá las razones sociales propietarias de los equipos si tu organización abarca varias firmas.',
    'Permite separar la flota por titular para rendiciones, seguros y costos.',
    'Si todos los equipos pertenecen a una sola firma, alcanza con crearla una vez y asignarla a todos.',
  ],
  nextSteps: [
    'Asignar la empresa propietaria a cada equipo desde su ficha.',
    'Los informes permiten filtrar y comparar los resultados por empresa.',
    'Asignar una empresa a un usuario, puede permitir que el mismo gestione equipos pertenecientes solo a esa empresa.',
  ],
};

const ConfiguracionEmpresas = (props) => {
  return (
    <ConfiguracionBase
      apiEndpoint="empresas"
      titulo="Empresas"
      descripcion="Empresas operativas para asociar a cada equipo"
      icon="fas fa-building"
      compact
      help={HELP}
      {...props}
    />
  );
};

export default ConfiguracionEmpresas;
